<template>
    <div :class="[tripList.length > 1 ? 'trip-summary' : '']">
        <div class="alert alert-warning" v-if="unallocatedStopList.length > 0">
            <button type="button" aria-hidden="true" class="close">×</button>
            <span>
                Could not route &nbsp;
                <a href="#" @click="handleUnassignedStopList(unallocatedStopList)">
                    {{ unallocatedStopListLength }} stops
                </a>
            </span>
        </div>
        <div class="md-layout md-size-100 trip-tools" v-if="hasDisplayed && tripList.length > 1">
            <div class="md-layout-item md-size-80 search-field">
                <div class="search-icon">
                    <md-icon>search</md-icon>
                </div>
                <search-component
                    :handle-search-on-type="true"
                    :search-icon="false"
                    :placeholder="placeholderText"
                    @onSearch="handleSearch"
                />
            </div>
            <div class="md-layout-item md-size-20 icon-pin-all">
                <a href="#" @click="onPinedAll" :class="{ active: isPinedAll }">
                    <md-icon class="route-pin-all">
                        push_pin
                    </md-icon>
                    <md-tooltip md-direction="right">
                        <span v-if="isPinedAll">
                            Unpin All
                        </span>
                        <span v-else>
                            Pin All
                        </span>
                    </md-tooltip>
                </a>
            </div>
        </div>
        <div class="table-wrapper" v-if="hasDisplayed">
            <md-table class="trip-table table-container accordion">
                <md-table-row v-if="orderedTripList.length > 0">
                    <md-table-head>Driver</md-table-head>
                    <md-table-head v-if="createMultiRuns">Run</md-table-head>
                    <md-table-head>Stops</md-table-head>
                    <md-table-head>Finish Time</md-table-head>
                    <md-table-head>
                        <form-group
                            class="vehicle-config"
                            v-if="
                                userCapacitySelections != null &&
                                    userCapacitySelections.length > 0
                            "
                        >
                            <md-select v-model="selectedCapacityType">
                                <md-option
                                    v-for="(vehicleCapacity, index) in userCapacitySelections"
                                    :key="index"
                                    :value="vehicleCapacity.type"
                                    class="vehicle-config"
                                >
                                    {{ vehicleCapacity.label }}
                                </md-option>
                            </md-select>
                        </form-group>
                    </md-table-head>
                    <md-table-head v-if="hasEmissions()">CO2/{{ userMetricValue }}</md-table-head>
                    <md-table-head />
                </md-table-row>
                <template v-for="(item, index) in orderedTripList">
                    <md-table-row
                        :key="index"
                        slot="md-table-row"
                        v-if="item.vehicle.isParentPlan === true || item.isActive === true || !createMultiRuns"
                        class="accordion-item-trigger"
                    >
                        <md-table-cell class="allocatestop">
                            <span :style="{ background: item.color }">&nbsp;</span>
                            <template v-if="item.vehicle.isParentPlan === true || !createMultiRuns">
                                <img
                                    v-if="item.teamMember.photoUrl"
                                    class="profile-image"
                                    :src="item.teamMember.photoUrl"
                                    @error="$_setDefaultBrokenImage"
                                    alt
                                />
                                <img v-else class="profile-image" :src="$root.defaultPhotoUrl" alt />

                                <span v-if="startLocationMode === 'teammembers'">{{ item.teamMember.fullName }}</span>
                                <span v-else>
                                    <a href="#" @click="handleAssignedTrip(item.vehicleId)">
                                        {{ item.teamMember.fullName }}
                                    </a>
                                </span>
                            </template>
                        </md-table-cell>
                        <md-table-cell class="allocatestop-run-number" v-if="createMultiRuns">
                            <span>{{ item.vehicle.runNumber }}</span>
                        </md-table-cell>
                        <md-table-cell class="allocatestop-number">
                            <a href="#" @click="handleAssignedStopList(item.vehicleId)">{{ item.stopsCount }} Stops</a>
                        </md-table-cell>
                        <md-table-cell class="finish-time">
                            {{ item.arrivalTime }}
                        </md-table-cell>
                        <md-table-cell
                            class="allocatestop-column"
                            v-if="
                                user.vehicleCapacityUnitsConfiguration != null &&
                                    user.vehicleCapacityUnitsConfiguration.length > 0
                            "
                        >
                            {{ getVehicleLoad(item.vehicle, item.teamMember) }}
                        </md-table-cell>
                        <md-table-cell v-if="hasEmissions()" class="emission-per-dist">
                            {{ item.vehicle.emissionPerDistance }}
                        </md-table-cell>
                        <md-table-cell class="allocatestop-pin">
                            <a
                                href="#"
                                @click="showTeamMemberSettingsModal(item)"
                                v-if="item.vehicle.isParentPlan || !createMultiRuns"
                            >
                                <md-icon class="route-pin">
                                    settings
                                </md-icon>
                            </a>
                            <a href="#" @click="allocateStopMarkers(item)" :class="{ active: item.isPinned }">
                                <md-icon class="route-pin">
                                    push_pin
                                </md-icon>
                            </a>
                            <span
                                class="accordion-item-trigger-icon"
                                v-if="item.vehicle.isParentPlan"
                                @click="toggle(item)"
                            ></span>
                        </md-table-cell>
                    </md-table-row>
                </template>
            </md-table>
            <div v-if="orderedTripList.length > 1" class="totals-footer">
                <md-table class="trip-table">
                    <md-table-row>
                        <md-table-cell class="total-stops-footer">{{ totalStops }} Stops</md-table-cell>
                        <md-table-cell class="total-capacity-footer">{{ totalLoad }}</md-table-cell>
                        <md-table-cell v-if="hasEmissions()" class="total-emission-footer">
                            {{ totalEmissions }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <div class="row">
                <div class="text-center">
                    <div class="checkbox-fixed-order">
                        <md-checkbox v-model="isFixedStopOrder">
                            Create Fixed Order Trips
                        </md-checkbox>
                        <md-tooltip class="fixed-order-tooltip" md-direction="bottom">
                            If selected, the trips created will have a fixed stop order as per the original planned
                            route.
                            <br />
                            If unselected, the stops will change order, allowing the trip to be automatically rerouted
                            when additional stops are added to the trip or if the driver doesn't follow the expected
                            stop order.
                        </md-tooltip>
                    </div>
                    <button class="custom-btn" @click="onCreateTrips()" v-if="createMultiRuns === true">
                        Create {{ tripList.filter((t) => t.vehicle.isParentPlan === true).length }} Trips
                    </button>
                    <button class="custom-btn" @click="onCreateTrips()" v-if="!createMultiRuns">
                        Create {{ tripList.length }} Trips
                    </button>
                    <md-button
                        title="Export Trips"
                        class="md-primary md-just-icon md-round pull-right header-button"
                        @click="onExportTrips()"
                    >
                        <md-icon>get_app</md-icon>
                    </md-button>
                    <md-button
                        v-if="!isStartRouting && !loadedSaveModel"
                        title="Save Optimise"
                        class="md-primary md-just-icon md-round pull-right header-button"
                        @click="onSaveOptimise()"
                    >
                        <md-icon>save</md-icon>
                    </md-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { SearchComponent } from '@/components';
import { mapGetters } from 'vuex';
import RoutingNameModal from '@/pages/BatchStop/Settings/RoutingNameModal';
import TeamMemberSettingsModal from '@/pages/BatchStop/StepComponents/TeamMemberSettingsModal';
import moment from 'moment';

export default {
    mixins: [GeneralMixin],
    name: 'TripSummary',
    components: {
        SearchComponent
    },
    props: {
        tripList: {
            type: Array,
            default: () => []
        },
        unallocatedStopList: {
            type: Array,
            default: () => []
        },
        hasDisplayed: {
            type: Boolean,
            default: false
        },
        isStartRouting: {
            type: Boolean,
            default: false
        },
        loadedSaveModel: {
            type: Boolean,
            default: false
        },
        startLocationMode: {
            type: String,
            default: null
        },
        startTripTime: {
            type: String,
            default: null
        },
        endTripTime: {
            type: String,
            default: null
        },
        createMultiRuns: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            unallocatedStopListLength: 0,
            isPinedAll: false,
            placeholderText: 'Find team member...',
            isFixedStopOrder: true,
            orderedTripList: [],
            userCapacitySelections:[],
            selectedCapacityType: null,
            capacityValues: null
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        totalStops() {
            if (this.orderedTripList.length > 0) {
                if (this.createMultiRuns === true) {
                    let totalStops = 0;
                    const parentVehicle = this.orderedTripList.filter((t) => t.vehicle.isParentPlan === true);
                    // eslint-disable-next-line  no-return-assign
                    parentVehicle.forEach((item) => {
                        const stopListCount = item.stops.filter((x) => x.stopId > 0).length;
                        totalStops += stopListCount;
                    });

                    return totalStops;
                }

                let totalStops = 0;
                // eslint-disable-next-line  no-return-assign
                this.orderedTripList.forEach((item) => (totalStops += item.stopsCount));
                return totalStops;
            }

            return 0;
        },
        totalLoad() {
            if (this.orderedTripList.length > 0) {
                let totalLoad = 0;
                let loadType = '';

                const trips =
                    this.createMultiRuns === true
                        ? this.orderedTripList.filter((t) => t.vehicle.isParentPlan === true)
                        : this.orderedTripList;
                // eslint-disable-next-line  no-return-assign
                trips.forEach((item) => {
                    if (!this.user?.vehicleCapacityUnitsConfiguration || !this.selectedCapacityType) 
                        return;

                    if (
                        !item.vehicle.vehicleLoad ||
                        !this.user.vehicleCapacityUnitsConfiguration ||
                        this.user.vehicleCapacityUnitsConfiguration.length <= 0
                    )
                        totalLoad += 0;

                    // eslint-disable-next-line no-unused-vars
                    const { symbol, defaultMaxCapacity } = this.user.vehicleCapacityUnitsConfiguration.find(
                        (x) => x.type === this.selectedCapacityType
                    );
                    loadType = symbol;

                    const load = item.vehicle.vehicleLoad[this.selectedCapacityType] ?? 0;
                    totalLoad += load;
                });

                const loadValue = totalLoad.toString();
                let total = totalLoad;
                if (loadValue.includes('.')) {
                    const numberOfDecimals = loadValue.split('.')[1].length;
                    if (numberOfDecimals > 2) {
                        total = total.toFixed(2);
                    }
                }

                return `${total} ${loadType}`;
            }

            return '';
        },
        totalEmissions() {
            /* eslint-disable no-param-reassign */
            const totalEmission = this.orderedTripList.reduce((accumulator, trip) => {
                // eslint-disable-next-line no-return-assign
                return (accumulator += trip.vehicle.emissionPerDistance);
            }, 0);
            /* eslint-enable no-param-reassign */
            return totalEmission.toFixed(2);
        },
        userMetricValue() {
            return this.user.speedUnits === 'kph' ? 'Km' : 'Mile';
        }
    },
    methods: {
        getVehicleLoad(vehicle, teamMember) {
            if (
                !vehicle.vehicleLoad ||
                !this.user.vehicleCapacityUnitsConfiguration ||
                this.user.vehicleCapacityUnitsConfiguration.length <= 0
            )
                return '';

            if (this.selectedCapacityType === null && this.user.vehicleCapacityUnitsConfiguration) {
                this.selectedCapacityType = this.user.vehicleCapacityUnitsConfiguration[0].type;
            }

            const { symbol, defaultMaxCapacity } = this.user.vehicleCapacityUnitsConfiguration.find(
                (x) => x.type === this.selectedCapacityType
            );

            let vehicleCapacity = teamMember.vehicleCapacity[this.selectedCapacityType] ?? defaultMaxCapacity;

            if (this.createMultiRuns === true && vehicle.isParentPlan && vehicle.numberOfRuns > 0) {
                vehicleCapacity *= vehicle.numberOfRuns;
            }

            const load = vehicle.vehicleLoad[this.selectedCapacityType];
            const displayMaxCapacity = vehicleCapacity ? `/${vehicleCapacity}` : '';
            vehicle.capacityValues = {};
            vehicle.capacityValues[this.selectedCapacityType] = vehicleCapacity;

            return `${load}${displayMaxCapacity} ${symbol} `;
        },
        onPinedAll() {
            const isPin = !this.isPinedAll;
            this.isPinedAll = isPin;
            this.orderedTripList.forEach((trip) => {
                trip.isPinned = isPin;
                this.$emit('allocateStopMarkers');
            });
        },
        handleSearch(value) {
            const { searchText } = value;
            if (searchText) {
                const filterTripList = this.tripList.filter((trip) => {
                    return trip.teamMember.fullName.toLowerCase().match(searchText.toLowerCase());
                });
                this.orderedTripList = filterTripList;
            } else {
                this.orderedTripList = this.getSortedTripList();
            }
        },
        handleAssignedStopList(vehicleId) {
            this.$emit('handleAssignedStopList', vehicleId, this.selectedCapacityType);
        },
        handleUnassignedStopList(stops) {
            this.$emit('handleUnassignedStopList', stops);
        },
        allocateStopMarkers(item) {
            item.isPinned = !item.isPinned;
            const tripPin = this.orderedTripList.map((trip) => trip.isPinned);
            this.isPinedAll = tripPin.every((value) => value === true);
            this.$emit('allocateStopMarkers');
        },
        onCreateTrips() {
            this.$emit('onCreateTrips', this.isFixedStopOrder);
        },
        handleAssignedTrip(vehicleId) {
            this.$emit('handleAssignedTrip', vehicleId);
        },
        onExportTrips() {
            this.$emit('onExportTrips');
        },
        getSortedTripList() {
            return this.tripList.slice().sort((x, y) => (x.vehicle.sortIndex > y.vehicle.sortIndex ? 1 : -1));
        },
        onSaveOptimise() {
            this.$modal.show(RoutingNameModal).then((response) => {
                this.$emit('onSaveOptimise', response);
            });
        },
        showTeamMemberSettingsModal(item) {
            this.$modal
                .show(TeamMemberSettingsModal, {
                    tripItem: item,
                    startTripTime: item.vehicle.customStartTime
                        ? item.vehicle.customStartTime
                        : moment(item.vehicle.vehicleStartTime).format('HH:mm'),
                    endTripTime: item.vehicle.customEndTime
                        ? item.vehicle.customEndTime
                        : moment(item.vehicle.vehicleEndTime).format('HH:mm'),
                    capacityValues: item.teamMember.vehicleCapacity
                })
                .then((response) => {
                    item.vehicle.customStartTime = response.startTime;
                    item.vehicle.customEndTime = response.endTime;
                    this.$emit('handleChangeTeamMemberSettings', response);
                });
        },
        hasEmissions() {
            return this.orderedTripList.some((x) => x.vehicle.emissionPerDistance);
        },
        toggle(vehicleItem) {
            const isActiveRun = !vehicleItem.isActive;
            this.orderedTripList.forEach((v) => {
                if (v.vehicle.teamMemberId === vehicleItem.vehicle.vehicleId) {
                    v.isActive = isActiveRun;
                }
            });
            this.orderedTripList = this.orderedTripList
                .slice()
                .sort((x, y) => (x.vehicle.sortIndex > y.vehicle.sortIndex ? 1 : -1));
        },
        startTransition(el) {
            el.style.height = `${el.scrollHeight}px`;
        },

        endTransition(el) {
            el.style.height = '';
        }
    },
    async mounted() {
        this.userCapacitySelections = this.user.vehicleCapacityUnitsConfiguration.filter(item => item.type !== 'length' && item.type !== 'width' && item.type !== 'height');
    },
    watch: {
        tripList() {
            if (this.tripList.length) {
                this.orderedTripList = this.getSortedTripList();
            }
        },
        unallocatedStopList() {
            this.unallocatedStopListLength = this.unallocatedStopList.length;
            const shipmentsCount = this.unallocatedStopList.filter((x) => x.shipment !== null);

            if (shipmentsCount) {
                this.unallocatedStopListLength += shipmentsCount.length;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.trip-summary {
    margin-top: -25px;
    .alert {
        margin-bottom: 0px;
        margin-top: 32px;
    }
}
.trip-table {
    padding-left: 0;
    line-height: 18px;
    list-style-type: none;
    max-height: 350px;
    background-color: transparent;
    ::v-deep > div {
        background-color: transparent !important;
    }
    ::v-deep .md-table-head {
        padding: 0px;
    }
    .md-table-cell {
        padding: 0px;
        border: 0px;
        height: 32px;
    }
    .address-container {
        max-width: 410px;
        .md-table-cell-container {
            white-space: nowrap;
            width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    td.md-table-cell.vehicle-capacity,
    td.md-table-cell.vehicle-capacity .md-table-cell-container {
        padding-right: 30px;
        text-align: right;
    }
    td.md-table-cell.vehicle-capacity,
    td.md-table-cell.vehicle-capacity .md-table-cell-container {
        padding-right: 30px;
        text-align: right;
    }
    .allocatestop {
        max-width: 170px;
        min-width: 150px;
        padding-right: 10px;

        ::v-deep div {
            white-space: nowrap;
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .allocateload {
        max-width: 100px;
        min-width: 80px;

        ::v-deep div {
            white-space: nowrap;
            width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .allocatestop a {
        color: #2b93ff;
    }
    .allocatestop-pin {
        max-width: 85px;
        min-width: 80px;
    }
    .active .md-icon.md-theme-default.md-icon-font {
        color: #2b93ff;
        transform: rotate(0deg);
    }
    td.md-table-cell.allocatestop,
    td.md-table-cell.allocatestop .md-table-cell-container {
        padding-left: 5px;
    }
    .route-pin {
        transform: rotate(90deg);
    }
    .profile-image {
        border-radius: 50%;
        height: 24px;
        width: 24px;
        box-shadow: none !important;
        border: 1px solid #eee;
    }
}
.md-content.md-table.trip-table.md-theme-default,
.md-content.md-table.trip-table.md-theme-default div {
    background-color: transparent;
}
.alert-warning a {
    color: #fdfdfd !important;
    text-decoration: underline !important;
}
.start-stop-route-btn {
    background-color: transparent;
    color: #2b93ff !important;
    border: 1px solid;
    width: 100%;
    max-width: 115px;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 38px;
    font-size: 15px;
    cursor: pointer;
    float: right;
}
.stop-routing-label {
    color: #999 !important;
}
.md-menu-content.md-select-menu {
    width: 100px !important;
}
.trip-tools {
    margin: 5px 0px;
    border-bottom: 1px solid #e8e8e8;
    .md-layout-item {
        padding: 0px;
    }
    .active .md-icon.md-theme-default.md-icon-font {
        color: #2b93ff;
        transform: rotate(0deg);
    }
    .route-pin-all {
        transform: rotate(90deg);
        margin-top: 8px;
        margin-right: 15px;
    }
    .icon-pin-all {
        a {
            float: right;
        }
    }
    .vehicle-units-filter {
        width: 85px;
        right: 75px;
        position: absolute;
        margin-top: 4px;
        ::v-deep input {
            border: 0px;
            background: transparent;
            text-align: right;
        }
    }
    .search--container {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        ::v-deep .md-field {
            box-sizing: border-box;
            margin: 0;
            padding: 3px 0px 0px 5px;
            &::before,
            &::after {
                bottom: 0px;
                display: none;
            }
        }
        ::v-deep input {
            font-size: 12px !important;
        }
        ::placeholder {
            font-size: 12px !important;
        }
        ::v-deep .md-clear {
            display: none;
        }
    }
    .search-field {
        .search-icon {
            float: left;
            width: 15px;
            padding: 8px 0px 0px;
            cursor: pointer;
        }
        i {
            font-size: 12px !important;
            color: #aaa;
        }
    }
}
.custom-btn {
    margin-right: 50px;
    margin-bottom: 0px;
}
.checkbox-fixed-order {
    float: left;
    padding-top: 15px;
    max-width: 180px;
    text-align: left;
    ::v-deep .md-checkbox-label {
        font-weight: 500;
        color: #333;
        padding-left: 5px;
    }
    ::v-deep .md-checkbox {
        margin: 5px;
    }
}
.checkbox-show-service-area {
    margin-top: 0px;
    margin-left: 5px;
    text-align: left;
    ::v-deep .md-checkbox-label {
        font-weight: 500;
        color: #333;
        padding-left: 5px;
    }
    ::v-deep .md-checkbox {
        margin: 5px;
    }
}
.vehicle-units {
    width: 85px;
    margin-top: -15px;
    float: right;
    ::v-deep input {
        border: 0px;
        background: transparent;
        text-align: right;
    }
}
.md-tooltip-bottom {
    &.fixed-order-tooltip {
        max-width: 450px;
        text-align: justify;
    }
}

.allocatestop-number {
    max-width: 80px;
    min-width: 80px;
}

.emission-per-dist {
    min-width: 70px;
    max-width: 80px;
}

.allocatestop-run-number {
    max-width: 50px;
    min-width: 50px;
}

.finish-time {
    min-width: 100px;
    max-width: 100px;
}

.vehicle-config {
    margin: -4px 0 0 !important;
    max-width: 100px;
    min-width: 90px;

    ::v-deep input {
        font-size: 1.0625rem !important;
        font-weight: 300;
    }
}

.table-wrapper {
    position: relative;
}

.table-container {
    max-height: 300px;
    overflow-y: auto;
}

.total-stops-footer {
    padding-left: 135px !important;
    width: 56%;
}

.total-capacity-footer {
}

.total-emission-footer {
    padding-left: 60px !important;
}

.accordion {
    padding: 0;

    div:not(:last-child) {
        border-bottom: 1px solid rgba(10, 10, 10, 0.1);
    }

    div:last-child .accordion-item-details {
        border-radius: 5px;
    }

    dd {
        margin-left: 0;
    }
}

.accordion-item-trigger,
.accordion-item-details-inner {
    padding: 0.75rem 1.25rem;
}

.accordion-item-title {
    position: relative;

    h4 {
        font-size: 1.25rem;
        margin-bottom: 0;
        padding-right: 1.25rem;
    }
}

.accordion-item-trigger-icon {
    $size: 8px;
    display: block;
    position: absolute;
    top: 0;
    right: 1.25rem;
    bottom: 0;
    margin: auto;
    width: $size;
    height: $size;
    border-right: 2px solid #363636;
    border-bottom: 2px solid #363636;
    transform: translateY(-$size / 4) rotate(45deg);
    transition: transform 0.2s ease;

    .is-active & {
        transform: translateY($size / 4) rotate(225deg);
    }
}

.accordion-item-details {
    overflow: hidden;
    background-color: whitesmoke;
}

.accordion-item-enter-active,
.accordion-item-leave-active {
    will-change: height;
    transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
    height: 0 !important;
}
</style>
